module.exports = __webpack_public_path__ + "img/kwai.e432031.svg";